module.exports = __webpack_public_path__ + "img/ca2fc2a.png";